<template>
    <div class="row">
        <div class="col-md-6">
            <!-- Inicio Tipo sistema -->
            <compania-sistema-tipo :id="id"
                v-bind="$props"
            /> 
            <compania-sistema-envios v-if="sistema == 'IPAS_WS' || sistema == 'GENERALI'" :id="id"
                v-bind="$props"
            /> 
            <!-- Fin Tipo sistema -->
        </div>

        <div class="col-md-6">
            <!-- Inicio provincias -->
            <compania-sistema-provincias :id="id" v-if="mostrarProvincias" v-bind="$props" />
            <!-- Fin provincias -->

            <!-- Inicio contratos-->
            <compania-sistema-contratos :id="id" v-bind="$props" />
            <!-- Fin contratos -->

            <!-- Inicio INTERPWGS -->
            <compania-sistema-interpwgs :id="id" v-bind="$props"/>
            <!-- Fin INTERPWGS -->

            <!-- Inicio especialidades ELBA -->
            <compania-sistema-especialidades-elba v-if="sistema == 'ELBA_WS'" :id="id" v-bind="$props"/>
            <!-- Fin especialidades ELBA -->

            <!-- Inicio Sistema Autofactura -->
            <compania-sistema-autofactura :id="id" v-bind="$props"/>
            <!-- Fin Sistema Autofactura -->
        </div>
    </div>
</template>
<script>
import { PwgsApi } from '../../../../services/PwgsApi'
import CompaniaSistemaTipo from './secciones/CompaniaSistemaTipo.vue'
import CompaniaSistemaProvincias from './secciones/CompaniaSistemaProvincias.vue'
import CompaniaSistemaContratos from './secciones/CompaniaSistemaContratos.vue'
import CompaniaSistemaInterpwgs from './secciones/CompaniaSistemaInterpwgs.vue'
import CompaniaSistemaEnvios from './secciones/CompaniaSistemaEnvios.vue'
import CompaniaSistemaEspecialidadesElba from './secciones/CompaniaSistemaEspecialidadesElba.vue'
import CompaniaSistemaAutofactura from './secciones/CompaniaSistemaAutofactura.vue'

export default {
    components: {
        CompaniaSistemaTipo,
        CompaniaSistemaProvincias,
        CompaniaSistemaInterpwgs,
        CompaniaSistemaContratos,
        CompaniaSistemaEnvios,
        CompaniaSistemaEspecialidadesElba,
        CompaniaSistemaAutofactura
    },
    data(){
        return{
            sistema: 'IPAS_WS',
            mostrarProvincias:false,
        }
    },
    props: {
        datos: {
            type: Object
        },
        id: {
            default: 0,
        }
    },
    methods: {
        async comprobarProvinciasActivado(){
            this.sistema = this.datos.sistema_compannia;
            const api = new PwgsApi();
            const compr1 = await api.get('parametros-pwgs/distribucion_expedientes_provincia');
            if(compr1.distribucion_expedientes_provincia==1 && this.datos.sistema_provincias==1){
                this.mostrarProvincias = true;
            }else{
                this.mostrarProvincias = false;
            }
        }
    },
    mounted() {
        this.comprobarProvinciasActivado();
    },
    watch: {
        datos() {
            this.comprobarProvinciasActivado();
        }   
    }
}
</script>